"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = require("lodash");
var message_const_1 = require("../const/message.const");
var time_const_1 = require("../const/time.const");
var numbers_1 = require("../numbers/numbers");
function fromSecondsToMinutes(seconds) {
    return lodash_1.round(seconds / time_const_1.SECONDS_PER_MINUTE, 2);
}
exports.fromSecondsToMinutes = fromSecondsToMinutes;
function fromMinutesToSeconds(minutes) {
    return minutes * time_const_1.SECONDS_PER_MINUTE;
}
exports.fromMinutesToSeconds = fromMinutesToSeconds;
function fromDaysToSeconds(days) {
    return lodash_1.round(days * time_const_1.HOURS_PER_DAY * time_const_1.MINUTES_PER_HOUR * time_const_1.SECONDS_PER_MINUTE, 2);
}
exports.fromDaysToSeconds = fromDaysToSeconds;
function formatStopWatch(value) {
    if (!value) {
        return message_const_1.FALLBACK_MESSAGE.dash;
    }
    else if (value > 0 && value < 60) {
        return '0 minutes';
    }
    var days = Math.floor(value / time_const_1.SECONDS_PER_DAY);
    var hours = Math.floor((value - days * time_const_1.SECONDS_PER_DAY) / time_const_1.SECONDS_PER_HOUR);
    var minutes = Math.floor((value - days * time_const_1.SECONDS_PER_DAY - hours * time_const_1.SECONDS_PER_HOUR) /
        time_const_1.MINUTES_PER_HOUR);
    var daysLabel = days ? " " + days + " day" + (days === 1 ? '' : 's') : '';
    var hoursLabel = hours ? " " + hours + " hour" + (hours === 1 ? '' : 's') : '';
    var minutesLabel = minutes ? " " + numbers_1.formatTwoDigits(minutes) + " min" : '';
    return "" + daysLabel + hoursLabel + minutesLabel;
}
exports.formatStopWatch = formatStopWatch;
